import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["type", "id", "value", "placeholder"]
const _hoisted_3 = ["id", "value", "placeholder"]
const _hoisted_4 = {
  key: 3,
  class: "text-danger"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("b", null, "Invalid field type in TextField component", -1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FieldError = _resolveComponent("FieldError")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: _ctx.id,
          class: "form-label"
        }, _toDisplayString(_ctx.label), 9, _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.type === 'text' || _ctx.type === 'password')
      ? (_openBlock(), _createElementBlock("input", {
          key: 1,
          type: _ctx.type,
          class: _normalizeClass(["form-control", {'is-invalid': _ctx.hasError}]),
          id: _ctx.id,
          value: _ctx.modelValue,
          placeholder: _ctx.placeholder,
          onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
        }, null, 42, _hoisted_2))
      : (_ctx.type === 'textarea')
        ? (_openBlock(), _createElementBlock("textarea", {
            key: 2,
            rows: "5",
            class: _normalizeClass(["form-control", {'is-invalid': _ctx.hasError}]),
            id: _ctx.id,
            value: _ctx.modelValue,
            placeholder: _ctx.placeholder,
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
          }, null, 42, _hoisted_3))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6)),
    _createVNode(_component_FieldError, { errors: _ctx.fieldErrors }, null, 8, ["errors"])
  ]))
}